module.exports = __webpack_public_path__ + "img/image-hotspot-wrap.44b2eebd.jpg";